/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

export * from './comments/comments.component';
export * from './whats-new/whats-new.component';